module.exports = __webpack_public_path__ + "assets/media/twitterIcon.72dc5e72.svg";